export const elasticApmTags = {
  API_TRANSACTION_SUCCESS: (data) => {
    return {
      event: 'eapm-api-transaction',
      transaction: data.transaction,
      type: 'http-request',
      data: {
        result: 'success',
        appVersion: process.env.PACKAGE_VERSION,
        url: window.location.href,
        uuid: data.uuid,
        ipAddress: data.ipAddress,
        optumId: data.optumId,
        duration: data.duration,
        username: data.username,
        status: data.status,
        endpoint: data.endpoint,
        operationName: data.operationName,
        resourceId: data.resourceId,
        code: data.code,
        message: data.message,
      },
    };
  },
  API_TRANSACTION_ERROR: (data) => {
    return {
      event: 'eapm-api-transaction',
      transaction: data.transaction,
      type: 'http-request',
      data: {
        result: 'error',
        appVersion: process.env.PACKAGE_VERSION,
        url: window.location.href,
        uuid: data.uuid,
        ipAddress: data.ipAddress,
        optumId: data.optumId,
        duration: data.duration,
        status: data.status,
        endpoint: data.endpoint,
        operationName: data.operationName,
        resourceId: data.resourceId,
        code: data.code,
        message: data.message,
        debug: data.debug,
      },
    };
  },
  CHAT_WHITELISTING_MODAL_OPEN: (data) => {
    return {
      event: 'eapm-chat-whitelisting-modal-opened',
      transaction: data.transaction,
      data: {
        eventName: 'Chat Whitelisting Modal Opened',
        isChatWhitelistingModalOpen: data.isChatModalOpen,
        uuid: data.uuid,
        optumId: data.optumId,
      },
    };
  },
  JAVASCRIPT_ERROR: (data) => {
    return {
      event: 'eapm-javascript-error',
      data: {
        appVersion: process.env.PACKAGE_VERSION,
        buildVersion: process.env.BUILD_TIMESTAMP,
        url: window.location.href,
        uuid: data.uuid,
        ipAddress: data.ipAddress,
        optumId: data.optumId,
        message: data.message,
        stack: data.stack,
      },
    };
  },
};
